import platform from 'platform-detect';

import config from '@/config';
import { FORM_FACTOR, FormFactor, OS, UserDevice } from '@/features/game/types';
import { isIosWrapper } from '@/features/game-context/platform-helpers';

export const isAndroidWrapper = () =>
  !!(
    (window.AndroidWrapper !== undefined &&
      window?.AndroidWrapper?.isWrapper?.()) ||
    window?.MobileWrapper?.getWrapperType?.() === 'Android'
  );

export const getUserOS = (): OS => {
  if (platform.macos) {
    return 'MAC';
  }
  if (platform.android) {
    return 'ANDROID';
  }
  if (platform.ios) {
    return 'IOS';
  }

  return 'WINDOWS';
};

export const getGameSpecificDevice = (): UserDevice => {
  const channel = platform.formfactor as FormFactor;
  return FORM_FACTOR?.[channel] ?? 'UNKNOWN';
};

export const getPlatformCode = () => {
  if (
    window.AndroidWrapper?.isWrapper?.() ||
    window.MobileWrapper?.isWrapper?.()
  ) {
    return config.cpp.platformCode.android;
  }
  if (getGameSpecificDevice().toLowerCase() === 'phone') {
    return config.cpp.platformCode.mobile;
  }

  return config.cpp.platformCode.desktop;
};

export const getPlatformType = () => {
  if (isAndroidWrapper()) {
    return 'ANDROID_APP';
  }

  if (isIosWrapper()) {
    return 'IOS_APP';
  }

  const os = getUserOS();

  if (os === 'ANDROID') {
    return 'ANDROID_WEB';
  }

  if (os === 'IOS') {
    return 'IOS_WEB';
  }

  return 'DESKTOP';
};

export const resolveProviderRef = (
  platformType: ReturnType<typeof getPlatformType>,
  providerRefDesktop?: string,
  providerRefMobile?: string,
  providerRef?: string,
): string | undefined => {
  const isDesktop = platformType === 'DESKTOP';
  return isDesktop
    ? providerRefDesktop ?? providerRefMobile ?? providerRef
    : providerRefMobile ?? providerRefDesktop ?? providerRef;
};
